import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import arrow from "../images/arrow.png";
import pages from "../images/Paper.svg";
import pen from "../images/pen.png";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { IoArrowBackOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { TailSpin } from "react-loader-spinner";
import { updateCandidateTab } from "../features/candidateTab";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { server_API } from "../config";
import plus from "../images/Tick Square.png";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import ModernDatePicker from "./ui/ModernDatePicker";
import download_black from "../images/download_balck.png"
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  useCSVReader,
  lightenDarkenColor,
  formatFileSize,
} from 'react-papaparse';
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import { CSVLink } from 'react-csv';
import { useSelector } from 'react-redux';
import { selectCid } from '../features/companyid';
import { getUserPrivilege, selectUuid } from '../features/userid';
import Copyright from './Copyright';
import { createNotification } from "./NotificationFunctions";
import axiosInstance from "../axiosInstance";
import { updateActiveInterviewedTab } from "../features/activeInterviewedTab";
import { updateSortedBy } from "../features/sortedBy";
import { updateCandidateFilters } from "../features/candidateFilters";
import { setCurrentPage } from '../features/pagination';
import { selectFilters, setFilter } from '../features/jobCandidateStore';
import OpenJob from "./modal/NewJob/OpenJob";

const GREY = '#CCC';
const GREY_LIGHT = 'rgba(255, 255, 255, 0.4)';
const DEFAULT_REMOVE_HOVER_COLOR = '#A01919';
const REMOVE_HOVER_COLOR_LIGHT = lightenDarkenColor(
  DEFAULT_REMOVE_HOVER_COLOR,

);
const GREY_DIM = '#686868';

const styles = {
  zone: {
    alignItems: "center",
    border: `2px dashed ${GREY}`,
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    padding: 20,
  },
  file: {
    background: "linear-gradient(to bottom, #EEE, #DDD)",
    borderRadius: 20,
    display: "flex",
    height: 120,
    width: 120,
    position: "relative",
    zIndex: 10,
    flexDirection: "column",
    justifyContent: "center",
  },
  info: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    paddingLeft: 10,
    paddingRight: 10,
  },
  size: {
    backgroundColor: GREY_LIGHT,
    borderRadius: 3,
    marginBottom: "0.5em",
    justifyContent: "center",
    display: "flex",
  },
  name: {
    backgroundColor: GREY_LIGHT,
    borderRadius: 3,
    fontSize: 12,
    marginBottom: "0.5em",
  },
  progressBar: {
    bottom: 14,
    position: "absolute",
    width: "100%",
    paddingLeft: 10,
    paddingRight: 10,
  },
  zoneHover: {
    borderColor: GREY_DIM,
  },
  default: {
    borderColor: GREY,
  },
  remove: {
    height: 23,
    position: "absolute",
    right: 6,
    top: 6,
    width: 23,
  },
};
//keep job title, department, jd, req, skills,
//pause to restart button in select

const today = new Date()
const Jobs = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()
  const filters = useSelector(selectFilters) || {};
  const [open, setOpen] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [view, setView] = useState(false);
  const [activeJob, setActiveJob] = useState({});
  const [title, setTitle] = useState(filters.jobs_filter_title || "");
  const [ws, setWs] = useState("");
  const [allJobs, setAllJobs] = useState("");
  const [link, setLink] = useState("");
  const [openLink, setOpenLink] = useState("");
  const [prompt, setPrompt] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [dept, setDept] = useState(filters.jobs_filter_dept || "");
  const userPrivilege = useSelector(getUserPrivilege)
  const [activeId, setActiveId] = useState("");
  const [ff, setFF] = useState(false);
  const [publishedJobs, setPublishedJobs] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [jobApplicants, setJobApplicants] = useState([]);
  const [loadingApplicants, setLoadingApplicants] = useState(false);
  const [closureReason, setClosureReason] = useState("");
  const [closureCandidateOptions, setClosureCandidateOptions] = useState([]);
  const [closureOtherReason, setClosureOtherReason] = useState("");
  const { CSVReader } = useCSVReader();
  const [zoneHover, setZoneHover] = useState(false);
  const [status, setStatus] = useState(filters.jobs_filter_status || "active");
  const [privilege, setPrivilege] = useState("");
  const [removeHoverColor, setRemoveHoverColor] = useState(
    DEFAULT_REMOVE_HOVER_COLOR
  );
  const [uploadManual, setUpload] = useState(false);
  const [csv, setCSV] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [openMenu, setOpenMenu] = useState(false);
  const [selectPopupValue, setSelectPopupValue] = useState("");
  const [draftjobId, setDraftJobId] = useState("");
  const [currentJobs, setCurrentJobs] = useState([]);
  const initStartDate = filters.jobs_filter_startingDate;
  const initEndDate = filters.jobs_filter_endingDate;
  const [startingDate, setStartingDate] = useState(initStartDate ? new Date(initStartDate) : "");
  const [endingDate, setEndingDate] = useState(initEndDate ? new Date(initEndDate) : "");

  useEffect(() => {
    dispatch(setFilter({ key: 'jobs_filter_title', value: title }));
    dispatch(setFilter({ key: 'jobs_filter_dept', value: dept }));
    dispatch(setFilter({ key: 'jobs_filter_status', value: status }));

    if (startingDate) {
      dispatch(setFilter({ key: 'jobs_filter_startingDate', value: startingDate.toISOString() }));
    } else {
      dispatch(setFilter({ key: 'jobs_filter_startingDate', value: "" }));
    }

    if (endingDate) {
      dispatch(setFilter({ key: 'jobs_filter_endingDate', value: endingDate.toISOString() }));
    } else {
      dispatch(setFilter({ key: 'jobs_filter_endingDate', value: "" }));
    }
  }, [title, dept, status, startingDate, endingDate, dispatch]);
  const currentPage = useSelector((state) => state.pagination.currentPage);
  const [totalPages, setTotalPages] = useState(1)
  const [jobReports, setJobReports] = useState([]);
  const csvLinkRef = useRef(null);
  const [fromAcfl, setFromAcfl] = useState(false);
  const navigate = useNavigate();
  const closureReasonOptions = [
    { value: "Hiring fully completed", label: "Hiring fully completed" },
    { value: "Hiring partially completed", label: "Hiring partially completed" },
    { value: "Job closed without hiring", label: "Job closed without hiring" },
    { value: "Incorrect posting", label: "Incorrect posting" },
    { value: "Others", label: "Others" },
  ];
  const onDrop = useCallback((acceptedFiles) => {
    console.log(acceptedFiles[0]);
  }, []);

  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      openPopup(false);
    }
  };


  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const perPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
  ];
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const cid = useSelector(selectCid);
  useEffect(() => {
    if (selectPopupValue.length > 0) {
      if (selectPopupValue == "view") {
        setView(true);
      } else if (selectPopupValue == "pause") {
        createNotification(cid, uuid, "", "Paused successfully", `${activeJob.profilename} has been successfully paused`)
        changeStatus(activeJob.uuid, "Paused");
      } else if (selectPopupValue == "close") {
        setOpenPopup(true);
        setActiveId(activeJob.uuid);
        resetClosureForm();
      } else if (selectPopupValue == "share") {
        setLink(activeJob.uuid);
        setOpenLink(true);
      } else if (selectPopupValue == "restart") {
        changeStatus(activeJob.uuid, "Open");
      } else if (selectPopupValue == "delete") {
        deleteJob(draftjobId);
      }
      else if (selectPopupValue == "edit") {
        localStorage.setItem('jid', activeJob.uuid)
        navigate('/jobs/new')
      }
      else if (selectPopupValue == "remind") {
        axiosInstance.post('/v2/job/approval/reminder', {
          "jobid": activeJob.uuid,
          "companyid": cid
        }).then(() => {
          toast.success("Reminder sent successfully");
        }).catch(() => {
          toast.error("Failed to send reminder");
        })
      }
    }
  }, [selectPopupValue]);

  const formatDateToYMD = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  console.log(userPrivilege)

  const headers = [
    { label: "Sr no.", key: "sr" },
    { label: "Job Title", key: "JobTitle" },
    { label: "Grade", key: "Grade" },
    { label: "Department", key: "Department" },
    { label: "Job Type", key: "JobType" },
    { label: "Work Style", key: "WorkStyle" },
    { label: "Total Positions", key: "TotalPositions" },
    { label: "Job Status", key: "JobStatus" },
    { label: "Open Date", key: "OpenDate" },
    { label: "Location", key: "Location" },
    { label: "Experience", key: "Experience" },
    { label: "Salary From", key: "SalaryFrom" },
    { label: "Salary To", key: "SalaryTo" },
    { label: "Hiring Manager", key: "HiringManager" },
    { label: "Recruiter", key: "Recruiter" },
    { label: "AI Interview", key: "AIInterview" },
    { label: "Technical Assessment", key: "TechnicalAssessment" },
    { label: "Resume Compatibility weightage", key: "ResumeCompatibilityWeightage" },
    { label: "Employability Skills weightage", key: "EmployabilitySkillsWeightage" },
    { label: "Technical Skills weightage", key: "TechnicalSkillsWeightage" },
    { label: "Voice Analysis weightage", key: "VoiceAnalysisWeightage" },
    { label: "Interview Language 1", key: "InterviewLanguage1" },
    { label: "Interview Language 2", key: "InterviewLanguage2" },
    { label: "Total Applications", key: "TotalApplications" },
    { label: "Total AI Interviews", key: "TotalAIInterviews" },
    { label: "Total in Interview Stages", key: "TotalInInterviewStages" },
    { label: "Total Selected Candidates", key: "TotalSelectedCandidates" },
    { label: "Total Offered", key: "TotalOffered" },
    { label: "Total Hired", key: "TotalHired" },
    { label: "Offer Rejecetd", key: "OfferRejected" },
    { label: "Total Rejected", key: "TotalRejected" },
    { label: "Total On-hold", key: "TotalOnHold" },
    { label: "Job Link", key: "JobLink" },
    { label: "Closure Reason", key: "ClosureReason" },
  ];


  useEffect(() => {
    sessionStorage.setItem("tab", 0);
    dispatch(updateCandidateTab(null))
    dispatch(updateActiveInterviewedTab(0))
    dispatch(updateSortedBy(''))
    dispatch(updateCandidateFilters(
      {
        sourceFilter: { value: "", label: "--" },
        fitmentFilter: { value: "", label: "--" },
        timeToJoinFilter: { value: "", label: "--" },
        startDate: "",
        endDate: "",
        page: 1,
        page_size: 10,
        updated: false
      }
    ))
    axios
      .get(`${server_API}/v2/company/get/${cid}`)
      .then((response) => {
        if (response.data.departments) {
          setDepartments(response.data.departments);
          console.log(response);
        } else {
          setDepartments([]);
        }
        setFromAcfl(response.data.from_acfl || false);
      })
      .catch((error) => {
        console.log(error);
      });
    axiosInstance.get(`/v2/user/getuser`, {
      withCredentials: true
    })
      .then((res) => {
        console.log(res)
        setPrivilege(res.data.success.privilege)
      })
      .catch((err) => {
        console.log(err)
      })
  }, []);

  const deleteJob = (id) => {
    axios
      .delete(`${server_API}/v2/job/delete/${id}/${cid}`)
      .then((response) => {
        console.log(response);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changeStatus = (id, status, closureData = {}) => {
    const payload = {
      uuid: id,
      companyid: cid,
      jobstatus: status,
    };

    if (status === "Closed") {
      payload.closure_reason = closureData.reason || "";
      payload.closure_candidate_ids = closureData.candidateIds || [];
      payload.closure_candidate_names = closureData.candidateNames || [];
      payload.closure_other_reason = closureData.otherReason || "";
    }

    axios
      .patch(`${server_API}/v2/job/update`, payload)
      .then((response) => {
        console.log(response);
        if (status == "closed") {
          setOpenPopup(false);
          window.location.reload();
        } else {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!openPopup || !activeId || !cid) return;

    const loadApplicants = async () => {
      setLoadingApplicants(true);
      try {
        const response = await axios.get(`${server_API}/v2/applicant/get/job/${activeId}/${cid}`);
        const applicants = Array.isArray(response.data) ? response.data : [];
        setJobApplicants(applicants);
      } catch (error) {
        setJobApplicants([]);
      } finally {
        setLoadingApplicants(false);
      }
    };

    loadApplicants();
  }, [openPopup, activeId, cid]);

  const requiresCandidateSelection =
    closureReason === "Hiring fully completed" || closureReason === "Hiring partially completed";

  const isClosureFormValid =
    !!closureReason &&
    (!requiresCandidateSelection || closureCandidateOptions.length > 0) &&
    (closureReason !== "Others" || !!closureOtherReason.trim());

  const resetClosureForm = () => {
    setClosureReason("");
    setClosureCandidateOptions([]);
    setClosureOtherReason("");
  };

  // useEffect(() => {
  //   if (jobs.length > 0 && allJobs.length > 0 && ff == false) {
  //     const filtered_array = jobs.filter((f) => {
  //       if (f.saveas != "template") {
  //         return f;
  //       }
  //     });
  //     const all = allJobs.filter((f) => {
  //       if (f.saveas != "template") {
  //         return f;
  //       }
  //     });
  //     setJobs(filtered_array);
  //     setAllJobs(allJobs);
  //     setFF(true);
  //   }
  // }, [jobs, allJobs]);

  const handleChange = (options) => {
    setSelectPopupValue(options.value);
    console.log(selectPopupValue);
  };

  const options = [
    { value: 'view', label: 'View Job Detail' },
    { value: 'pause', label: 'Pause' },
    { value: 'close', label: 'Close' },
    { value: 'share', label: 'Share' },
  ]
  const resOptions = [
    { value: 'view', label: 'View Job Detail' },
    { value: 'restart', label: 'Resume' },
    { value: 'close', label: 'Close' },
    { value: 'share', label: 'Share' },
  ]
  const closedOptions = [
    { value: 'view', label: 'View Job Detail' },
    { value: 'restart', label: 'Open' },

  ]
  const viewOptions = [
    { value: 'view', label: 'View' },
    { value: 'share', label: 'Share' },
  ]
  const draftOptions = [
    { value: 'edit', label: 'Edit' },
    { value: 'delete', label: 'Delete' }
  ]
  const pendingOptions = [
    { value: 'view', label: 'View Job Detail' },
    { value: 'remind', label: 'Remind' },
    { value: 'close', label: 'Close' },
  ]


  // useEffect(()=>{
  //   if(publishedJobs.length>0){
  //     var filtered = publishedJobs
  //       if(dept.length>0){
  //         filtered  = filtered.filter((f)=>{
  //           return(f.department == dept)
  //         })
  //       }
  //       if(ws.length>0){
  //         filtered  = filtered.filter((f)=>{
  //           return(f.workstyle == ws)
  //         }) 
  //       }
  //       if(title.length>0){
  //         filtered = filtered.filter((f)=>{
  //           return (f.profilename.toLowerCase().includes(title.toLocaleLowerCase()))
  //         })
  //       }
  //       if(status.length > 0){
  //         filtered = filtered.filter((f)=>{

  //           return (f.jobstatus.toLowerCase().includes(status))

  //         })
  //       }
  //       if (startingDate || endingDate) {
  //         filtered = filtered.filter((f) => {
  //           const jobDate = new Date(f.postdate);


  //           jobDate.setHours(0, 0, 0, 0);
  //           if (startingDate) startingDate.setHours(0, 0, 0, 0);
  //           if (endingDate) endingDate.setHours(23, 59, 59, 999); 
  //           if (startingDate && endingDate) {
  //             return (
  //               jobDate.getTime() >= startingDate.getTime() &&
  //               jobDate.getTime() <= endingDate.getTime()
  //             );
  //           } else if (startingDate) {
  //             return jobDate.getTime() >= startingDate.getTime();
  //           } else if (endingDate) {
  //             return jobDate.getTime() <= endingDate.getTime();
  //           }

  //           return true;
  //         });

  //         console.log("Filtered (Before Sort):", filtered);
  //       }



  //     setJobs(filtered)
  //   }
  // },[title, ws, dept, status,startingDate,endingDate])


  const popUpOptions = (jobstatus) => {
    if (jobstatus == "Paused") {
      return resOptions
    }
    if (jobstatus == "Draft") return draftOptions
    if (jobstatus == "Closed") return closedOptions
    if (jobstatus == "Pending") return pendingOptions
    return options
  }

  const newRef = useRef(null);
  const viewRef = useRef(null);
  const shareRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (newRef.current && !newRef.current.contains(e.target)) {
      setOpenPopup(false);
      window.location.reload();
    } else if (shareRef.current && !shareRef.current.contains(e.target)) {
      setOpenLink(false);
      window.location.reload();
    } else if (viewRef.current && !viewRef.current.contains(e.target)) {
      setView(false);
      window.location.reload();
    }
  };


  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const uuid = useSelector(selectUuid);

  const fetchAndExportJobReport = async () => {
    setLoader(true)
    try {
      const response = await axios.get(`${server_API}/v2/job/getreport/${cid}`)
      console.log(response); // your API endpoint
      const data = response.data.jobs; // assuming it's an array of JobReport

      const formattedData = data.map((job, index) => ({
        sr: index + 1,
        JobTitle: job.job_title,
        Grade: job.grade || "",
        Department: job.department,
        JobType: job.job_type,
        WorkStyle: job.work_style,
        TotalPositions: job.total_positions,
        JobStatus: job.job_status,
        OpenDate: job.open_date,
        Location: job.location,
        Experience: job.experience,
        SalaryFrom: job.salary_from,
        SalaryTo: job.salary_to,
        HiringManager: job.hiring_manager,
        Recruiter: job.recruiter,
        AIInterview: job.ai_interview ? "Yes" : "No",
        TechnicalAssessment: job.technical_assessment ? "Yes" : "No",
        ResumeCompatibilityWeightage: job.resume_compatibility_weightage,
        EmployabilitySkillsWeightage: job.employability_skills_weightage,
        TechnicalSkillsWeightage: job.technical_skills_weightage,
        VoiceAnalysisWeightage: job.voice_analysis_weightage,
        InterviewLanguage1: job.interview_language_1,
        InterviewLanguage2: job.interview_language_2,
        TotalApplications: job.total_applications,
        TotalAIInterviews: job.total_ai_interviews,
        TotalInInterviewStages: job.total_in_interview_stages,
        TotalSelectedCandidates: job.total_selected_candidates,
        TotalOffered: job.total_offered,
        TotalHired: job.total_hired,
        OfferRejected: job.offer_rejected,
        TotalRejected: job.total_rejected,
        TotalOnHold: job.total_on_hold,
        JobLink: job.job_link,
        ClosureReason: job.closure_reason || "",
      }));


      setJobReports(formattedData);

      // Trigger CSV download after short delay
      setTimeout(() => {
        csvLinkRef.current.link.click();
        setLoader(false)
      }, 500);
    } catch (err) {
      console.error("Failed to fetch job report:", err);
      setLoader(false)
    }
  };



  const fetchJobs = async () => {
    try {
      const params = new URLSearchParams({
        page: currentPage.toString(),
        page_size: itemsPerPage.toString(),
        department: dept,
        title: title,
        ws: ws,
        postedFrom: formatDateToYMD(startingDate),
        postedTo: formatDateToYMD(endingDate),
        status: status,
        userid: uuid,
      });

      const response = await axios.get(
        `${server_API}/v2/job/getall/${cid}?${params.toString()}`
      );

      let fetchedJobs = response.data.jobs;
      setJobs(fetchedJobs);
      setTotalPages(response.data.total_pages);
    } catch (error) {
      console.error("Failed to fetch jobs", error);
    }
  };



  useEffect(() => {
    fetchJobs();
  }, [dept, title, startingDate, endingDate, status, itemsPerPage, currentPage, ws]);



  useEffect(() => {
    window.scrollTo(0, 0);


    axios
      .get(`${server_API}/v2/job/getall/${cid}`)
      .then((res) => {
        console.log(res);
        setAllJobs(res.data);
        // setJobs(res.data)
      })
      .catch((err) => {
        setAllJobs([]);
        console.log(err);
      });

  }, []);

  useEffect(() => {
    if (allJobs.length > 0) {
      const published_jobs = allJobs.filter((job) => {
        if (job.saveas == "publish" || job.saveas == "draft" || job.saveas == "Pending") {
          return job;
        }
      });
      setJobs(published_jobs);
      let dat = published_jobs.map((a) => ({ ...a }));
      let data = dat.map((m, i) => {
        m["no"] = i + 1;
        m["firstlanguage"] = "English";
        if (m.preferredlanguage == "EN") {
          m["secondlanguage"] = "-";
        } else if (m.preferredlanguage == "HI") {
          m["secondlanguage"] = "Hindi";
        } else {
          m["secondlanguage"] = "Malay";
        }
        m[
          "link"
        ] = `https://interviewguru.co/#/careers/${m.uuid}/${m.companyid}`;
        delete m.uuid;
        delete m.companyid;
        delete m.questionid;
        // delete m.normaltext
        delete m.closedate;
        delete m.saveas;
        delete m.jobdescription;
        delete m.skills;
        delete m.assignrecruiter;
        delete m.assignhiringmanager;
        delete m.firstreminder;
        delete m.finalreminder;
        delete m.selectedapplication;
        delete m.updatedat;
        return m;
      });
      setCsvData(data);
      setPublishedJobs(published_jobs);
    }
  }, [allJobs]);

  console.log(csvData);




  // useEffect(()=>{
  //   const reversedJobs = [...jobs].reverse();
  // const sortedJobs = reversedJobs?.sort((a, b) => {
  //   if (a.jobstatus.toLowerCase() === "closed" && b.jobstatus.toLowerCase() !== "closed") return 1;
  //   if (a.jobstatus.toLowerCase() !== "closed" && b.jobstatus.toLowerCase() === "closed") return -1;
  //   return 0;
  // });
  // const sortedJobsDateWise = sortedJobs?.sort((a, b) => {
  //   const d1 = new Date(a.createdat).getTime()
  //   const d2 = new Date(b.createdat).getTime()
  //   if(d1<d2) return 1;
  //   if(d1>=d2) return -1;
  // })
  //   setCurrentJobs(
  //     sortedJobsDateWise.slice(indexOfFirstJob, indexOfLastJob)
  //   )
  // },[currentPage,jobs])

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      dispatch(setCurrentPage(newPage));
    }
  };

  const getPageRange = () => {
    const maxVisiblePages = 3;
    const middlePage = currentPage;
    let startPage = middlePage - Math.floor(maxVisiblePages / 2);
    startPage = Math.max(startPage, 1);
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };


  return (
    <div>
      <Tooltip id="my-tooltip"></Tooltip>
      {departments != null && (
        <div>
          {uploadManual && (
            <div className="fixed bg-white p-4 z-40 h- rounded-xl left-1/2 top-1/2 -translate-x-1/2 w-1/3  -translate-y-1/2">
              <div className="flex justify-between items-center my-4 px-2">
                <p className="font-semibold">Add new candidate</p>
                <button
                  className="text-right my-2"
                  onClick={() => {
                    setUpload(false);
                  }}
                >
                  X
                </button>
              </div>
              <CSVReader
                onUploadAccepted={(results) => {
                  console.log(results);
                  setZoneHover(false);
                }}
                onDragOver={(event) => {
                  event.preventDefault();
                  setZoneHover(true);
                }}
                onDragLeave={(event) => {
                  event.preventDefault();
                  setZoneHover(false);
                }}
              >
                {({
                  getRootProps,
                  acceptedFile,
                  ProgressBar,
                  getRemoveFileProps,
                  Remove,
                }) => (
                  <>
                    <div
                      className=""
                      {...getRootProps()}
                      style={Object.assign(
                        {},
                        styles.zone,
                        zoneHover && styles.zoneHover
                      )}
                    >
                      {acceptedFile ? (
                        <>
                          <div style={styles.file}>
                            <div style={styles.info}>
                              <span style={styles.size}>
                                {formatFileSize(acceptedFile.size)}
                              </span>
                              <span style={styles.name}>
                                {acceptedFile.name}
                              </span>
                            </div>
                            <div style={styles.progressBar}>
                              <ProgressBar />
                            </div>
                            <div
                              {...getRemoveFileProps()}
                              style={styles.remove}
                              onMouseOver={(event) => {
                                event.preventDefault();
                                setRemoveHoverColor(REMOVE_HOVER_COLOR_LIGHT);
                              }}
                              onMouseOut={(event) => {
                                event.preventDefault();
                                setRemoveHoverColor(DEFAULT_REMOVE_HOVER_COLOR);
                              }}
                            >
                              <Remove color={removeHoverColor} />
                            </div>
                          </div>
                          <button className="w-full bg-[#0DCD94] text-white my-5 rounded-xl py-5 ">
                            Map attributes
                          </button>
                        </>
                      ) : (
                        <div className="w-full">
                          <img src={plus} className="h-12 mx-auto"></img>
                          <p className="text-[#0DCD94] text-center mt-5 text-xl font-semibold">
                            Select a CSV file to upload
                          </p>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </CSVReader>
            </div>
          )}
          {
            openLink &&
            <OpenJob navigate={navigate} jid={link} cid={cid} setOpenPopup={() => { setSelectPopupValue(""); setOpenLink(false); }} navigateToJob heading="Share Job!" />
          }
          {openPopup && (
            <div ref={newRef} className="">
              <div className="fixed bg-white  shadow-xl md:w-1/2  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="p-3 rounded-xl text-center  ">
                  <p className="font-semibold text-xl">
                    Are you sure you want to close this job?
                  </p>
                  <div className="flex w-full justify-around mt-5">
                    <button
                      className="text-red-500 border-red-500 border rounded-xl py-2 px-5 "
                      onClick={() => {
                        setOpenPopup(false);
                        setSelectPopupValue("");
                        resetClosureForm();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className={`border rounded-xl py-2 px-6 ${isClosureFormValid
                        ? "bg-red-500 text-white border-red-500"
                        : "bg-gray-300 text-gray-500 border-gray-300 cursor-not-allowed"
                        }`}
                      disabled={!isClosureFormValid}
                      onClick={() => {
                        if (!closureReason) {
                          toast.error("Please select a hiring status before closing this job");
                          return;
                        }
                        if (requiresCandidateSelection && closureCandidateOptions.length === 0) {
                          toast.error("Please select candidate name before closing this job");
                          return;
                        }
                        if (closureReason === "Others" && !closureOtherReason.trim()) {
                          toast.error("Please provide closure reason details");
                          return;
                        }

                        const candidateIds = closureCandidateOptions.map((item) => item.value);
                        const candidateNames = closureCandidateOptions.map((item) => item.label);

                        createNotification(cid, activeJob.assignrecruiter, "", "Closed successfully", `${activeJob.profilename} has been successfully closed`)
                        createNotification(cid, activeJob.assignhiringmanager, "", "Closed successfully", `${activeJob.profilename} has been successfully closed`)
                        changeStatus(activeId, "Closed", {
                          reason: closureReason,
                          candidateIds,
                          candidateNames,
                          otherReason: closureOtherReason.trim(),
                        });
                        setSelectPopupValue("");
                        resetClosureForm();
                      }}
                    >
                      Close
                    </button>
                  </div>
                  <div className="mt-6 text-left">
                    <p className="font-semibold text-sm mb-2">Please select a hiring status of this job before closure</p>
                    <Select
                      placeholder="Select reason"
                      value={closureReasonOptions.find((option) => option.value === closureReason) || null}
                      options={closureReasonOptions}
                      onChange={(option) => {
                        setClosureReason(option?.value || "");
                        setClosureCandidateOptions([]);
                      }}
                    />

                    {requiresCandidateSelection && (
                      <div className="mt-3">
                        <p className="font-semibold text-sm mb-2">Select candidate name</p>
                        <Select
                          isMulti
                          isLoading={loadingApplicants}
                          placeholder={loadingApplicants ? "Loading candidates..." : "Select candidate(s)"}
                          options={jobApplicants.map((applicant) => ({
                            value: applicant.uuid,
                            label: applicant.name,
                          }))}
                          value={closureCandidateOptions}
                          onChange={(options) => setClosureCandidateOptions(options || [])}
                        />
                      </div>
                    )}

                    {closureReason === "Others" && (
                      <div className="mt-3">
                        <p className="font-semibold text-sm mb-2">Please specify</p>
                        <input
                          value={closureOtherReason}
                          onChange={(e) => setClosureOtherReason(e.target.value)}
                          className="w-full border rounded-md px-3 py-2 text-sm"
                          placeholder="Enter reason"
                        />
                      </div>
                    )}
                    {!isClosureFormValid && (
                      <p className="mt-3 text-xs text-red-500">
                        Please complete mandatory fields to continue.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {view && (
            <div
              ref={viewRef}
              className="fixed bg-white p-4 border shadow-xl z-40 h-screen mb-5 overflow-y-scroll rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-h-[60vh]"
            >
              <button
                onClick={() => {
                  setView(false);
                  setSelectPopupValue("");
                }}
              >
                <p className="text-right ">X</p>
              </button>
              <div className="p-5  rounded-xl ">
                <div className="flex flex-col space-y-4">
                  <div className="flex w-full ">
                    <p className="font-semibold w-1/2">
                      Job Title:
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.profilename}
                      </span>
                    </p>
                    <p className="font-semibold w-1/2">
                      Job type:
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.jobtype}
                      </span>
                    </p>
                  </div>
                  <div className="flex w-full ">
                    <p className="font-semibold w-1/2">
                      No of positions:
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.positionnumber}
                      </span>
                    </p>
                    <p className="font-semibold w-1/2">
                      Department:
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.department}
                      </span>
                    </p>
                  </div>

                  <div className="flex w-full ">
                    {/* <p className="font-semibold w-1/2">
                      Last date to apply:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.applicationlastdate.split("-")[2]}-
                        {activeJob.applicationlastdate.split("-")[1]}-
                        {activeJob.applicationlastdate.split("-")[0]}
                      </span>
                    </p> */}
                    <p className="font-semibold w-1/2">
                      Experience:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.experience}
                      </span>
                    </p>
                    {activeJob.grade && (
                      <p className="font-semibold w-1/2">
                        Grade:{" "}
                        <span className="text-[#8F94A1] font-normal">
                          {activeJob.grade}
                        </span>
                      </p>
                    )}
                  </div>

                  <div className="flex w-full ">
                    <p className="font-semibold w-1/2">
                      Salary from:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.salaryfrom}
                      </span>
                    </p>
                    <p className="font-semibold w-1/2">
                      Salary to:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.salaryto}
                      </span>
                    </p>
                  </div>
                  <div className="flex w-full ">
                    <p className="font-semibold w-1/2">
                      Location:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob["location:"]}
                      </span>
                    </p>
                  </div>

                  <div className="flex w-full ">
                    <p className={fromAcfl ? "font-semibold w-1/2" : "font-semibold w-full"}>
                      Work style:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.workstyle}
                      </span>
                    </p>
                    {fromAcfl && (
                      <p className="font-semibold w-1/2">
                        Position Type:{" "}
                        <span className="text-[#8F94A1] font-normal">
                          {activeJob.position_type || "N/A"}
                        </span>
                      </p>
                    )}
                  </div>

                  {activeJob.position_type === "Replacement" && (
                    <>
                      <p className="font-semibold w-1/2">
                        Replacement Name:{" "}
                        <span className="text-[#8F94A1] font-normal font-sans">
                          {activeJob.acfl_detail?.replacement_employee_name || activeJob.replacement_fields?.replacement_employee_name || "N/A"}
                        </span>
                      </p>
                      <p className="font-semibold w-1/2">
                        Replacement Code:{" "}
                        <span className="text-[#8F94A1] font-normal font-sans">
                          {activeJob.acfl_detail?.replacement_employee_code || activeJob.replacement_fields?.replacement_employee_code || "N/A"}
                        </span>
                      </p>
                      <p className="font-semibold w-1/2">
                        Replacement Location:{" "}
                        <span className="text-[#8F94A1] font-normal font-sans">
                          {activeJob.acfl_detail?.replacement_employee_location || activeJob.replacement_fields?.replacement_employee_location || "N/A"}
                        </span>
                      </p>
                      <p className="font-semibold w-1/2">
                        Replacement Designation:{" "}
                        <span className="text-[#8F94A1] font-normal font-sans">
                          {activeJob.acfl_detail?.replacement_employee_designation || activeJob.replacement_fields?.replacement_employee_designation || "N/A"}
                        </span>
                      </p>
                    </>
                  )}
                </div>
                {activeJob.new_position_comments && (
                  <div className="my-2 flex gap-1">
                    <p className="font-semibold">Comments:</p>
                    <p className="text-[#8F94A1] font-normal">{activeJob.new_position_comments}</p>
                  </div>
                )}
                {(activeJob.acfl_detail || activeJob.replacement_fields) && (
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
                    <p className="font-semibold mb-2 text-sm text-gray-700">Extra Details</p>
                    <div className="grid grid-cols-2 gap-y-2">
                      <p className="font-semibold text-xs">
                        Active Employees (Same Grade):{" "}
                        <span className="text-[#8F94A1] font-normal font-sans">
                          {activeJob.acfl_detail?.active_employees_same_grade || activeJob.replacement_fields?.active_employees_same_grade || "N/A"}
                        </span>
                      </p>
                      <p className="font-semibold text-xs">
                        Min Salary (Same Grade):{" "}
                        <span className="text-[#8F94A1] font-normal font-sans">
                          {activeJob.acfl_detail?.min_salary_same_grade || activeJob.replacement_fields?.min_salary_same_grade || "N/A"}
                        </span>
                      </p>
                      <p className="font-semibold text-xs">
                        Max Salary (Same Grade):{" "}
                        <span className="text-[#8F94A1] font-normal font-sans">
                          {activeJob.acfl_detail?.max_salary_same_grade || activeJob.replacement_fields?.max_salary_same_grade || "N/A"}
                        </span>
                      </p>
                      <p className="font-semibold text-xs">
                        Maximum Age:{" "}
                        <span className="text-[#8F94A1] font-normal">
                          {activeJob.min_dob || "N/A"}
                        </span>
                      </p>
                      <p className="font-semibold text-xs">
                        Minimum Education:{" "}
                        <span className="text-[#8F94A1] font-normal">
                          {activeJob.min_education || "N/A"}
                        </span>
                      </p>
                    </div>
                  </div>
                )}
                <div>
                  <div className="flex items-center space-x-3">
                    <p className="mb-2 font-semibold">Job Description:</p>
                  </div>
                  {/* <div className="text-[#8F94A1] " dangerouslySetInnerHTML={{__html: activeJob.jobdescription}}></div>
                     */}
                  <ReactQuill
                    value={activeJob.jobdescription}
                    readOnly={true}
                    theme="bubble"
                  ></ReactQuill>
                  {/* {activeJob.description} */}
                </div>

                <div>
                  <p className="mb-2 font-semibold">Skills weightage:</p>
                  <div className="flex space-x-5">
                    <p className="font-semibold w-1/2">
                      Resume compatibility score:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.resumecompatibility}
                      </span>
                    </p>
                    <p className="font-semibold w-1/2">
                      AI interview score:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.aiscore}
                      </span>
                    </p>
                    <p className="font-semibold w-1/2">
                      Voice analysis score:{" "}
                      <span className="text-[#8F94A1] font-normal">
                        {activeJob.voiceanalysisscore}
                      </span>
                    </p>
                    {activeJob.technicalweight > 0 && (
                      <p className="font-semibold w-1/2">
                        Technical analysis score:{" "}
                        <span className="text-[#8F94A1] font-normal">
                          {activeJob.technicalweight}
                        </span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
          }
          <div className={openPopup || view || uploadManual || openLink ? "bg-[#f0f4fc] blur  min-h-screen " : "bg-[#f0f4fc] min-h-screen"}>
            <div className="p-4 md:px-10 pb-0 pt-5">
              <div className="flex items-center py-3 justify-between">
                <div className='flex gap-4 items-center'>     <Link to="/home">  <IoArrowBackOutline className='w-7 cursor-pointer h-7 ' /></Link>
                  <p className="text-[28px] font-semibold">My Jobs</p></div>


                <div className="relative flex items-center space-x-4">
                  <div>
                    {
                      csvData.length > 0 &&
                      <CSVLink className="bg-[#0DCD94] flex items-center justify-center py-[12px] px-[20px] h-full text-[14px] text-white   rounded-[4px]" filename='All jobs' data={csvData} headers={
                        [
                          { label: "Sr no.", key: "no" },
                          { label: "Job Title", key: "profilename" },
                          { label: "Department", key: "department" },
                          { label: "Job Type", key: "jobtype" },
                          { label: "Work Style", key: "workstyle" },
                          { label: "Total Positions", key: "positionnumber" },
                          { label: "Job Status", key: "jobstatus" },
                          { label: "Open Date", key: "postdate" },
                          { label: "Location", key: "location:" },
                          { label: "Interview Language 1", key: "firstlanguage" },
                          { label: "Interview Language 2", key: "secondlanguage" },
                          { label: "Job Link", key: "link" },
                          { label: "Experience", key: "experience" },
                          { label: "Salary From", key: "salaryfrom" },
                          { label: "Salary To", key: "salaryto" },
                          { label: "Resume Compatibility weightage", key: "resumecompatibility" },
                          { label: "Soft Skills weightage", key: "aiscore" },
                          { label: "Technical weightage", key: "technicalweight" },
                          { label: "Total Applications", key: "totalapplication" },
                          { label: "Interviewed", key: "interviewed" }
                        ]
                      }>
                        Export Data
                      </CSVLink>
                    }
                  </div>
                  <div className="relative flex gap-2 items-center">
                    {privilege !== "Hiring Manager" && (
                      <>
                        {/* Download Report Button */}
                        <button
                          onClick={fetchAndExportJobReport}
                          className="relative bg-[#F1F4FB] p-1.5 rounded-md flex justify-center items-center h-fit group"
                        >
                          {loader ? (
                            <TailSpin color="#374151" height={20} width={20} />
                          ) : (
                            <img
                              src={download_black}
                              className="text-slate-700 cursor-pointer w-7 h-7"
                            />
                          )}
                          <p className="absolute transition-all text-xs left-1/2 -translate-x-1/2 top-9 text-center px-3 py-1 z-20 scale-0 rounded-md bg-black/70 text-white shadow-md group-hover:scale-100 whitespace-nowrap">
                            Download report
                          </p>
                        </button>

                        {/* Add Job Button + Dropdown */}
                        <div className="relative">
                          <button
                            className={`py-[10px] h-full px-[10px] text-[12px] bg-[#148EFF] text-white rounded-[4px] flex items-center justify-between min-w-[100px] ${open ? "rounded-b-none" : ""
                              }`}
                            onClick={() => setOpen(!open)}
                          >
                            Add Job
                            <img
                              src={arrow}
                              className={`ml-2 h-[6px] transition-transform ${open ? "rotate-180" : ""
                                }`}
                            />
                          </button>

                          {/* Dropdown */}
                          {open && (
                            <div className="absolute left-0 mt-0 w-full text-[14px] bg-[#5AA7EF] text-white rounded-b-[4px] shadow-md overflow-hidden z-10">
                              <Link to="/settings">
                                <button className="w-full flex items-center space-x-2 py-3 px-3 hover:bg-[#4a95d5] text-[12px]">
                                  <img src={pages} className="h-4" />
                                  <p>Templates</p>
                                </button>
                              </Link>
                              <Link to="/jobs/new">
                                <button
                                  onClick={() => localStorage.removeItem("jid")}
                                  className="w-full flex items-center space-x-2 py-3 px-3 hover:bg-[#4a95d5] text-[12px]"
                                >
                                  <img src={pen} className="h-3" />
                                  <p>Manually</p>
                                </button>
                              </Link>
                            </div>
                          )}
                        </div>

                        {/* Hidden CSV Link */}
                        <CSVLink
                          data={jobReports}
                          headers={headers}
                          filename="Job_Report.csv"
                          className="hidden"
                          ref={csvLinkRef}
                          target="_blank"
                        />
                      </>
                    )}
                  </div>


                </div>
              </div>
              <div className=" mt-3 bg-white rounded-xl">
                <div className="md:flex p-6 filter-container  w-full items-end justify-start gap-[14px]">
                  <div className='w-[200px]'>
                    <p className="font-semibold text-sm ">Job Title</p>
                    <input placeholder='Enter Job Title' value={title} onChange={(e) => { setTitle(e.target.value) }}
                      className="custom-placeholder text-[14px] w-full border  py-1 rounded-[4px] mt-1 h-[2.35rem] px-2  border-[#D2D4DA] font-semibold text-[#8f94a1] "
                      type="text"></input>
                  </div>
                  <div className="w-[200px]">
                    <p className="font-semibold text-sm mb-1">Department</p>

                    <Select
                      placeholder="Select Department"
                      className='text-[14px]'

                      onChange={(selectedOption) => {
                        setDept(selectedOption.value)
                      }}
                      options={[{ value: '', label: 'Select Department' }, ...departments.map(d => ({ value: d, label: d }))]}
                    ></Select>
                  </div>
                  <div className='w-[200px]'>
                    <p className="font-semibold text-sm mb-1">Status</p>

                    <Select
                      placeholder="Select Status"
                      className='text-[14px]'
                      onChange={(selectedOption) => {
                        setStatus(selectedOption.value)
                      }}
                      options={[
                        { value: 'active', label: '--' },
                        { value: 'Open', label: 'Open' },
                        { value: 'Paused', label: 'Paused' },
                        { value: 'Closed', label: 'Closed' },
                        { value: 'Draft', label: 'Draft' },
                        { value: 'Pending', label: 'Pending' },
                      ]}
                    ></Select>
                  </div>
                  <div className="w-[280px]">
                    <div className="text-sm mb-1 font-semibold">
                      Posting Date
                    </div>
                    <div className="flex gap-2">
                      <ModernDatePicker
                        value={startingDate}
                        onChange={(date) => {
                          setStartingDate(date);
                          if (!endingDate || (endingDate < date)) {
                            setEndingDate(null);
                          }
                        }}
                        maxDate={today}
                        placeholder="From"
                        inputClassName="!rounded-[4px] !h-[2.35rem]"
                      />
                      <ModernDatePicker
                        value={endingDate}
                        onChange={(date) => setEndingDate(date)}
                        minDate={startingDate || null}
                        maxDate={today}
                        placeholder="To"
                        inputClassName="!rounded-[4px] !h-[2.35rem]"
                      />
                    </div>
                  </div>
                  {/* <div className='w-1/4'>
              <p className="font-semibold">Work style</p>
              <select onChange={(e)=>{setWs(e.target.value)}} value={ws} className="border w-full  px-1 py-1 rounded-lg mt-1">
                <option value="">--</option>
                <option value="On-Site">On-site</option>
                <option value="Remote">Remote</option>
                <option value="Hybrid">Hybrid</option>
              </select>
            </div> */}

                  {/* <button onClick={()=>{search()}} className="py-2 h-full  bg-[#148EFF] text-white px-12 rounded-lg">Search</button> */}
                </div>
                <div className="border-[#E9EBFA] border w-full"></div>
                <div className=" p-6">

                  <Table className="">
                    <Thead className="text-center text-sm sticky font-semibold top-0 z-30  bg-white">
                      <Tr>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">S.No</Th>
                        <Th className="border-y border-[#D2D4DA] px-4 text-left  ">Job Title</Th>
                        <Th className="border-y border-[#D2D4DA] p-2">Work Style</Th>


                        <Th className="border-y border-[#D2D4DA] p-2">Open Date</Th>
                        <Th className="border-y border-[#D2D4DA] p-2">Openings</Th>
                        {/* <Th className="border-y border-[#D2D4DA] p-2">Closed Date</Th> */}
                        <Th className="border-y border-[#D2D4DA] text-center p-2">Applications</Th>
                        <Th className="border-y border-[#D2D4DA] text-center p-2">Selected</Th>
                        <Th className="border-y border-[#D2D4DA] text-center p-2">Offers</Th>
                        <Th className="border-y border-[#D2D4DA] text-center p-2">Hired</Th>
                        <Th className="border-y border-[#D2D4DA] p-2">Status</Th>
                        <Th className="border-y border-[#D2D4DA] p-2">Actions</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {
                        jobs?.map((j, i) => {
                          return (
                            <Tr className="text-sm text-center ">
                              <Td className="border-y border-[#D2D4DA] p-2 text-center  "> {((currentPage - 1) * itemsPerPage) + i + 1}</Td>
                              <Td className="border-y border-[#D2D4DA] p-4 text-left w-52 max-w-56">
                                {
                                  j.saveas !== "draft" && j.saveas !== "Pending" ? (
                                    <Link
                                      onClick={() => {
                                        sessionStorage.setItem('currentPage', 1);
                                        sessionStorage.setItem('currentInterviewedPage', 1);
                                        sessionStorage.setItem('currentShortlistedPage', 1);
                                        sessionStorage.setItem('currentRejectedPage', 1);
                                      }}
                                      to="/jobs/candidates/temp"
                                      className="text-[#148EFF] h-fit w-fit cursor-pointer"
                                      state={{ id: j.uuid }}
                                    >
                                      <div className='cursor-pointer w-fit'>
                                        <p className='w-fit text-[14px] text-left mb-[4px]'>{j.profilename}</p>
                                        <p className="text-black text-[10px] w-fit">
                                          {j.department}
                                        </p>
                                      </div>
                                    </Link>
                                  ) : j.saveas === "Pending" ? (
                                    <div className='text-left w-fit'>
                                      <p className='w-fit text-[14px] font-semibold text-left mb-[4px] text-[#444D63]'>{j.profilename}</p>
                                      <p className="text-black text-[10px] w-fit">
                                        {j.department}
                                      </p>
                                    </div>
                                  ) : (
                                    <div className='text-[#148EFF] text-left w-fit cursor-pointer'>
                                      {
                                        userPrivilege !== "Hiring Manager" ? (
                                          <button
                                            className="text-left"
                                            onClick={() => {
                                              localStorage.setItem('jid', j.uuid);
                                              navigate('/jobs/new');
                                            }}
                                          >
                                            {j.profilename}
                                          </button>
                                        ) : (
                                          <span className="text-gray-400 cursor-not-allowed">
                                            {j.profilename}
                                          </span>
                                        )
                                      }
                                      <p className="text-black text-xs my-1 w-fit">
                                        {j.department}
                                      </p>
                                    </div>
                                  )
                                }
                              </Td>


                              <Td className="border-y border-[#D2D4DA] p-2">{j.workstyle ? j.workstyle : "-"}</Td>
                              <Td className="border-y border-[#D2D4DA] p-2">{`${(j.postdate.split('T')[0]).split('-')[2]}-${(j.postdate.split('T')[0]).split('-')[1]}-${(j.postdate.split('T')[0]).split('-')[0]}`}</Td>
                              {/* <Td className="border-y border-[#D2D4DA] p-2">{
                      e.applicationlastdate.length>0 &&
                    `${e.applicationlastdate.split('-')[2]}-${e.applicationlastdate.split('-')[1]}-${e.applicationlastdate.split('-')[0]}`
                    }
                    </Td> */}
                              <Td className="border-y border-[#D2D4DA] p-2 text-center">{j.positionnumber}</Td>
                              <Td className="border-y border-[#D2D4DA] p-2 text-center">{j.totalapplication}</Td>
                              <Td className="border-y border-[#D2D4DA] p-2 text-center">{j.selectedapplication}</Td>
                              <Td className="border-y border-[#D2D4DA] p-2 text-center">{j.offeredcount}</Td>
                              <Td className="border-y border-[#D2D4DA] p-2 text-center">{j.hiredcount}</Td>
                              <Td
                                className={`border-y border-[#D2D4DA] text-center p-2 font-medium ${j.jobstatus === "Paused"
                                  ? "text-[#FE9933]"
                                  : j.jobstatus === "Open"
                                    ? "text-[#40B2B7E5]"
                                    : j.jobstatus === "Closed"
                                      ? "text-[#E95060]"
                                      : j.jobstatus === "Draft"
                                        ? "text-[#444D63]"
                                        : j.jobstatus === "Pending"
                                          ? "text-[#9da20f]"
                                          : ""
                                  }`}

                              >
                                {j.jobstatus}
                              </Td>
                              <Td className="border-y border-[#D2D4DA] p-2 text-left w-[140px] text-[12px] ">
                                <div className=" w-full justify-center space-x-4 items-center relative" >
                                  <Select
                                    value={selectPopupValue}
                                    onChange={(option) => {
                                      setActiveJob(j)
                                      setSelectPopupValue(option.value)
                                      if (option.value == "delete") {
                                        setDraftJobId(j.uuid)
                                      }
                                      else if (option.value == "edit") {
                                        localStorage.setItem('jid', j.uuid)
                                        navigate('/jobs/new')
                                      }
                                    }}
                                    isDisabled={userPrivilege == "Hiring Manager"}
                                    options={popUpOptions(j.jobstatus)}
                                  ></Select>
                                  {/* {
                          privilege != "Viewer"?
                          <div>
                            {
                              j.jobstatus.toLowerCase()=="paused"
                              ?
                            <Select value={selectPopupValue}
                             className='single-action'
                            placeholder={"Select Action"}
                            onChange={(option)=>{
                              setSelectPopupValue(option.value)
                              setActiveJob(j)
                            }}
                            options={resOptions}></Select>
                            :
                            <Select value={selectPopupValue}
                            placeholder={"Select Action"}
                              className='single-action'
                            onChange={(option)=>{
                              setSelectPopupValue(option.value)
                              setActiveJob(j)
                              if(j.jobstatus =="Draft")
                              {
                               setDraftJobId(j.uuid);
                            
                                localStorage.setItem('jid', j.uuid)
                                navigate('/jobs/new')
                          
                              }
                            }}
                            options={j.jobstatus =="Draft"?draftOptions: j.jobstatus =="Closed" ?closedOptions:options}></Select>
                            }
                          </div>
                        :
                        <Select value={selectPopupValue}
                        placeholder={"Select Action"}
                          className='single-action'
                        onChange={(option)=>{
                          setSelectPopupValue(option.value)
                          setActiveJob(j)
                        }}
                        options={viewOptions}></Select>
                        } */}



                                </div>
                              </Td>
                            </Tr>
                          )
                        })
                      }
                    </Tbody>
                  </Table>

                  <nav className="bg-white px-4 py-6 flex items-center justify-between border-t border-gray-200 sm:px-6">
                    {/* Left side: Page size selector */}
                    <div className="hidden sm:block">
                      <label htmlFor="pageSize" className="text-sm text-gray-700 mr-2">
                        Jobs per page:
                      </label>
                      <select
                        id="pageSize"
                        value={itemsPerPage}
                        onChange={(e) => {
                          dispatch(setCurrentPage(1));
                          setItemsPerPage(Number(e.target.value));
                        }}
                        className="border border-gray-300 rounded-md px-3 py-1 text-sm"
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </select>
                    </div>

                    {/* Right side: Pagination */}
                    <div className="flex justify-between sm:justify-end gap-1">
                      <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${currentPage === 1 ? "opacity-50" : "hover:bg-gray-50"
                          }`}
                      >
                        Previous
                      </button>

                      <div className="flex space-x-2">
                        {currentPage > 4 && (
                          <>
                            <button
                              onClick={() => handlePageChange(1)}
                              className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${currentPage === 1 ? "bg-light-blue text-white" : ""
                                }`}
                            >
                              1
                            </button>
                            <button
                              onClick={() => handlePageChange(2)}
                              className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${currentPage === 2 ? "bg-light-blue text-white" : ""
                                }`}
                            >
                              2
                            </button>
                            <span className="px-2 text-gray-500 text-4xl flex">...</span>
                          </>
                        )}

                        {getPageRange().map((page) => (
                          <button
                            key={page}
                            onClick={() => handlePageChange(page)}
                            className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${currentPage === page ? "bg-light-blue text-white" : ""
                              }`}
                          >
                            {page}
                          </button>
                        ))}
                      </div>

                      <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${currentPage === totalPages ? "opacity-50" : "hover:bg-gray-50"
                          }`}
                      >
                        Next
                      </button>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <Copyright />
          </div>
        </div>
      )
      }

    </div >
  )
}

export default Jobs